import { type ConsentChoice, signalsFor } from "@/lib/consent/signals";

/**
 * Minimal gtag(). Consent Mode commands must reach the dataLayer as an
 * `arguments` object — a plain object (what sendGTMEvent pushes) is treated as
 * an event and the consent state is never updated.
 */
export function gtag(..._args: unknown[]): void {
  window.dataLayer = window.dataLayer || [];
  // biome-ignore lint/complexity/noArguments: Consent Mode requires the Arguments object
  window.dataLayer.push(arguments);
}

export function updateConsent(choice: ConsentChoice): void {
  gtag("consent", "update", signalsFor(choice));
}
